<template>
	<el-dialog
		v-dialogDrag
		class="friend-group-manager-shell im-dialog-shell im-dialog-shell--xl im-dialog-shell--mobile-center"
		title="好友分组"
		:visible.sync="show"
		:width="dialogWidth"
		:before-close="close"
		custom-class="friend-group-manager-dialog"
		top="4vh"
		append-to-body
	>
		<div class="friend-group-manager" :class="{ 'is-mobile': isMobileView }" v-loading="loading">
			<div class="group-sidebar">
				<div class="panel-head sidebar-head">
					<div class="panel-meta">
						<div class="panel-title">我的分组</div>
						<div class="result-badge">{{ groups.length }}</div>
					</div>
					<el-button
						type="primary"
						size="mini"
						icon="el-icon-plus"
						:loading="creating"
						@click="onCreateGroup"
					>
						新建分组
					</el-button>
				</div>
				<el-scrollbar class="sidebar-scroll">
					<empty-state
						v-if="groups.length === 0"
						class="list-empty-state"
						icon="el-icon-folder-opened"
						title="暂无好友分组"
						hint="创建后可在建群和转发中直接批量选择"
						compact
					></empty-state>
					<div
						v-for="group in groups"
						:key="group.id"
						class="group-item"
						:class="{ active: group.id === activeGroupId }"
						@click="onSelectGroup(group)"
					>
						<div class="group-item-head">
							<div class="group-name" :title="group.name">{{ group.name }}</div>
							<div class="group-count">{{ resolveGroupMemberCount(group) }}</div>
						</div>
					</div>
				</el-scrollbar>
			</div>
			<div v-if="activeGroup" class="group-detail">
				<div class="panel-head detail-head">
					<div class="detail-title-row">
						<div class="panel-title">分组信息</div>
						<div class="detail-actions">
							<el-button
								type="danger"
								plain
								size="mini"
								:disabled="saving"
								@click="onDeleteGroup"
							>
								删除分组
							</el-button>
							<el-button
								type="primary"
								size="mini"
								:loading="saving"
								:disabled="!hasPendingChanges || saving"
								@click="onSaveGroup"
							>
								保存变更
							</el-button>
						</div>
					</div>
					<el-input
						v-model.trim="draftName"
						size="small"
						maxlength="20"
						show-word-limit
						placeholder="请输入分组名称"
					></el-input>
				</div>
				<div class="detail-body">
					<div class="left-box">
						<div class="panel-head">
							<el-input v-model="searchText" size="small" clearable placeholder="搜索好友昵称或完整账号">
								<i class="el-icon-search el-input__icon" slot="suffix"></i>
							</el-input>
							<div class="select-tools">
								<el-button
									type="text"
									size="mini"
									:disabled="loading || sourceSelectableCount === 0"
									@click="onSelectAll"
								>
									全选
								</el-button>
								<div class="select-tools__actions">
									<div class="result-badge">{{ selectableFriendTotalCount }}</div>
									<el-button
										type="text"
										icon="el-icon-delete"
										class="icon-btn clear-btn"
										:disabled="checkCount === 0"
										title="清空"
										@click="onClearChecked"
									></el-button>
								</div>
							</div>
						</div>
						<empty-state
							v-if="showFriends.length === 0"
							class="scroll-box list-empty-state"
							icon="el-icon-search"
							:title="currentEmptyTitle"
							compact
						></empty-state>
								<virtual-scroller
									v-else
									class="scroll-box"
									:items="showFriends"
									:item-height="42"
									:item-key-getter="getSourceFriendKey"
									@reach-bottom="onSourceListReachBottom"
						>
							<template v-slot="{ item: friend }">
								<friend-item :friend="friend" :menu="false" size="small" @click.native="onToggleFriend(friend.id)">
									<span class="add-tip">加入</span>
								</friend-item>
							</template>
						</virtual-scroller>
					</div>
					<div class="right-box">
						<div class="panel-head selection-head">
							<div class="panel-title compact-title">
								<i class="el-icon-user-solid"></i>
								<span>已选成员</span>
								<span class="inline-count">{{ checkCount }}</span>
							</div>
							<el-button
								v-if="checkCount > 0"
								type="text"
								icon="el-icon-delete"
								class="icon-btn clear-btn"
								title="清空已选"
								@click="onClearChecked"
							></el-button>
						</div>
						<empty-state
							v-if="checkedFriends.length === 0"
							class="scroll-box list-empty-state compact-empty"
							icon="el-icon-user"
							title="请选择要加入分组的好友"
							compact
						></empty-state>
								<virtual-scroller
									v-else
									class="scroll-box checked-scroll-box"
									:items="checkedFriendsView"
									:item-height="54"
									:item-key-getter="getCheckedFriendKey"
									@reach-bottom="onCheckedListReachBottom"
								>
							<template v-slot="{ item: friend }">
							<div
								class="checked-item"
								@click="onToggleFriend(friend.id)"
							>
								<head-image :url="friend.headImage" :name="friend.showNickName" :size="34"></head-image>
								<div class="checked-main">
									<div class="checked-name">{{ friend.showNickName }}</div>
								</div>
								<div class="close" title="移除">
									<i class="el-icon-close"></i>
								</div>
							</div>
							</template>
						</virtual-scroller>
					</div>
				</div>
			</div>
			<empty-state
				v-else
				class="detail-empty-state"
				icon="el-icon-folder-add"
				title="请选择一个好友分组"
				hint="或者先创建一个新的好友分组"
			></empty-state>
		</div>
		<span slot="footer" class="dialog-footer">
			<el-button @click="close" :disabled="saving || creating">关 闭</el-button>
		</span>
	</el-dialog>
</template>

<script>
import HeadImage from '../common/HeadImage.vue';
import FriendItem from './FriendItem.vue';
import VirtualScroller from '../common/VirtualScroller.vue';
import { CONTACT_SEARCH_TEXT_KEY, matchesPreparedContactKeyword } from '../../utils/contactSearchMatcher';

function normalizeName(name) {
	return String(name || '').trim();
}

function normalizeIdKey(id) {
	if (id === undefined || id === null || id === '') {
		return '';
	}
	return String(id);
}

function normalizeIds(ids) {
	return Array.isArray(ids)
		? ids.filter((id, index, list) => id && list.indexOf(id) === index)
		: [];
}

function sameIds(leftIds, rightIds) {
	const left = normalizeIds(leftIds);
	const right = normalizeIds(rightIds);
	if (left.length !== right.length) {
		return false;
	}
	return left.every((id, index) => id === right[index]);
}

const CHECKED_RESULT_PAGE_SIZE = 30;

export default {
	name: 'friendGroupManager',
	components: {
		HeadImage,
		FriendItem,
		VirtualScroller
	},
	data() {
		return {
			show: false,
			loading: false,
			saving: false,
			creating: false,
			searchText: '',
			activeGroupId: null,
			draftName: '',
				draftFriendIds: [],
				originName: '',
				originFriendIds: [],
				checkedViewLimit: CHECKED_RESULT_PAGE_SIZE,
				openPromise: null,
			sourceFriendHydrationPromise: null,
			activeGroupHydrationPromise: null,
			activeGroupMembersHydrated: false
		};
	},
	computed: {
		isMobileView() {
			return this.configStore.isMobile;
		},
		dialogWidth() {
			return this.configStore.isMobile ? '100%' : '980px';
		},
		groups() {
			return this.friendGroupStore.groups;
		},
		activeGroup() {
			return this.friendGroupStore.findGroup(this.activeGroupId) || null;
		},
		selectedFriendIdSet() {
			return new Set(this.draftFriendIds);
		},
		normalizedSearchText() {
			return String(this.searchText || '').trim().toLowerCase();
		},
		friendSelectionState() {
			const showFriends = [];
			const checkedFriends = [];
			const keyword = this.normalizedSearchText;
			const selectedFriendIdSet = this.selectedFriendIdSet;
			const selectedFriendKeySet = new Set(this.draftFriendIds.map(normalizeIdKey).filter(Boolean));
			const activeGroupKey = normalizeIdKey(this.activeGroupId);
			this.friendStore.friends.forEach((friend) => {
				if (!friend || friend.deleted) {
					return;
				}
				const friendKey = normalizeIdKey(friend.id);
				if (selectedFriendIdSet.has(friend.id) || selectedFriendKeySet.has(friendKey)) {
					checkedFriends.push(friend);
					return;
				}
				const friendGroupKey = normalizeIdKey(friend.groupId)
					|| this.friendGroupStore.friendToGroupMap.get(friendKey)
					|| '';
				if (activeGroupKey && friendGroupKey === activeGroupKey) {
					return;
				}
				if (!matchesPreparedContactKeyword(friend[CONTACT_SEARCH_TEXT_KEY], keyword)) {
					return;
				}
				showFriends.push(friend);
			});
			return {
				showFriends,
				checkedFriends
			};
		},
		showFriends() {
			return this.friendSelectionState.showFriends;
		},
		checkedFriends() {
			return this.friendSelectionState.checkedFriends;
		},
		checkedFriendsView() {
			const limit = Math.max(CHECKED_RESULT_PAGE_SIZE, Math.floor(Number(this.checkedViewLimit) || 0));
			if (this.checkedFriends.length <= limit) {
				return this.checkedFriends;
			}
			return this.checkedFriends.slice(0, limit);
		},
		checkCount() {
			return this.checkedFriends.length;
		},
		sourceSelectableCount() {
			return this.showFriends.length;
		},
			selectableFriendTotalCount() {
				const declaredTotal = Math.max(0, Math.floor(Number(this.friendStore.page.total || 0)));
				if (declaredTotal > 0) {
					return declaredTotal;
				}
				return this.friendSelectionState.showFriends.length + this.friendSelectionState.checkedFriends.length;
			},
		hasPendingChanges() {
			if (!this.activeGroup) {
				return false;
			}
			if (normalizeName(this.draftName) !== normalizeName(this.originName)) {
				return true;
			}
			return !sameIds(this.draftFriendIds, this.originFriendIds);
		},
		currentEmptyTitle() {
			return String(this.searchText || '').trim() ? '无结果' : '暂无可添加好友';
		}
	},
		methods: {
			getSourceFriendKey(friend) {
				const key = friend && friend.id ? String(friend.id) : '';
				return key ? `source:${key}` : '';
			},
			getCheckedFriendKey(friend) {
				const key = friend && friend.id ? String(friend.id) : '';
				return key ? `checked:${key}` : '';
			},
			async open() {
			this.show = true;
			this.loading = true;
			this.searchText = '';
			const openTask = (async () => {
				try {
					const nextActiveId = this.activeGroupId && this.friendGroupStore.findGroup(this.activeGroupId)
						? this.activeGroupId
						: (this.groups[0] && this.groups[0].id);
					const nextGroup = this.friendGroupStore.findGroup(nextActiveId);
					const hasExistingGroups = Array.isArray(this.groups) && this.groups.length > 0;
					if (hasExistingGroups) {
						this.syncDraftFromGroup(nextGroup);
						// 先复用现有缓存，避免每次打开弹窗都阻塞等待远端请求。
						await this.hydrateDraftFriendIds(nextGroup);
					}
					await this.friendGroupStore.loadGroups({
						limit: 30
					});
					const resolvedGroupId = this.activeGroupId && this.friendGroupStore.findGroup(this.activeGroupId)
						? this.activeGroupId
						: (this.friendGroupStore.groups[0] && this.friendGroupStore.groups[0].id);
					const resolvedGroup = this.friendGroupStore.findGroup(resolvedGroupId);
					this.syncDraftFromGroup(resolvedGroup);
					await this.hydrateDraftFriendIds(resolvedGroup);
					if (this.friendGroupStore.page.more && this.friendGroupStore.page.cursor) {
						this.friendGroupStore.ensureGroupListFullyLoaded({
							limit: 30
						}).catch((error) => {
							console.warn('FriendGroupManager 后台续拉好友分组失败', error);
						});
					}
				} catch (error) {
					this.$message.error(this.extractErrorMessage(error) || '加载好友分组失败');
					this.syncDraftFromGroup(null);
				}
			})();
			this.openPromise = openTask;
			try {
				await openTask;
			} finally {
				if (this.openPromise === openTask) {
					this.openPromise = null;
				}
				this.loading = false;
			}
		},
		async close(done) {
			if (this.saving || this.creating) {
				return;
			}
			if (!await this.confirmLeaveWithPendingChanges()) {
				return;
			}
			this.searchText = '';
			if (typeof done === 'function') {
				done();
				return;
			}
			this.show = false;
		},
		async confirmLeaveWithPendingChanges() {
			if (!this.hasPendingChanges) {
				return true;
			}
			try {
				await this.$confirm('当前分组还有未保存修改，继续离开会丢失本次编辑内容。', '未保存修改', {
					confirmButtonText: '继续离开',
					cancelButtonText: '返回编辑',
					type: 'warning',
					closeOnClickModal: false,
					closeOnPressEscape: false
				});
				return true;
			} catch (error) {
				return false;
			}
		},
			syncDraftFromGroup(group) {
				this.activeGroupId = group && group.id ? group.id : null;
				this.draftName = group && group.name ? group.name : '';
				this.draftFriendIds = [];
				this.checkedViewLimit = CHECKED_RESULT_PAGE_SIZE;
				this.originName = this.draftName;
				this.originFriendIds = [...this.draftFriendIds];
			this.activeGroupMembersHydrated = false;
			this.activeGroupHydrationPromise = null;
		},
		async hydrateDraftFriendIds(group) {
			if (!group || !group.id) {
				this.activeGroupMembersHydrated = true;
				return;
			}
			const activeGroupId = group.id;
			try {
				await this.friendGroupStore.ensureGroupFriendsFullyLoaded(group.id, {
					limit: 30,
					includeOnline: false
				});
			} catch (error) {
				console.warn('FriendGroupManager 加载分组成员详情失败', group.id, error);
			}
			if (this.activeGroupId !== activeGroupId) {
				return;
			}
			const loadedFriendIds = normalizeIds(
				this.friendGroupStore.findGroupFriends(group.id).map((friend) => friend && friend.id).filter(Boolean)
			);
			this.draftFriendIds = loadedFriendIds;
			this.originFriendIds = [...loadedFriendIds];
			this.activeGroupMembersHydrated = true;
		},
		ensureSourceFriendsFullyLoaded() {
			if (this.sourceFriendHydrationPromise) {
				return this.sourceFriendHydrationPromise;
			}
			const task = this.friendStore.ensureFriendListFullyLoaded({
				limit: 30
			}).finally(() => {
				if (this.sourceFriendHydrationPromise === task) {
					this.sourceFriendHydrationPromise = null;
				}
			});
			this.sourceFriendHydrationPromise = task;
			return task;
		},
		ensureActiveGroupMembersFullyHydrated(options = {}) {
			const group = this.activeGroup;
			if (!group || !group.id || this.activeGroupMembersHydrated) {
				return Promise.resolve(this.draftFriendIds);
			}
			if (this.activeGroupHydrationPromise) {
				return this.activeGroupHydrationPromise;
			}
			const previousLoading = this.loading;
			if (!options.background) {
				this.loading = true;
			}
			const task = this.hydrateDraftFriendIds(group).finally(() => {
				if (!options.background) {
					this.loading = previousLoading;
				}
				if (this.activeGroupHydrationPromise === task) {
					this.activeGroupHydrationPromise = null;
				}
			});
			this.activeGroupHydrationPromise = task;
			return task;
		},
		async reloadGroupsAndResolveGroup(preferGroupId = null, preferName = '') {
			const groups = await this.friendGroupStore.loadGroups({
				forceReload: true,
				limit: 30
			});
			if (preferGroupId) {
				const matchedById = this.friendGroupStore.findGroup(preferGroupId);
				if (matchedById) {
					return matchedById;
				}
			}
			const normalizedName = normalizeName(preferName);
			if (normalizedName) {
				const matchedByName = groups.find((group) => normalizeName(group && group.name) === normalizedName);
				if (matchedByName) {
					return matchedByName;
				}
			}
			return groups[0] || null;
		},
		resolveGroupMemberCount(group) {
			return `${Number(group && group.memberCount) || 0} 人`;
		},
		async onSelectGroup(group) {
			if (!group || !group.id) {
				return;
			}
			if (group.id === this.activeGroupId) {
				return;
			}
			if (!await this.confirmLeaveWithPendingChanges()) {
				return;
			}
			this.searchText = '';
			this.syncDraftFromGroup(group);
			await this.hydrateDraftFriendIds(group);
		},
		async onCreateGroup() {
			if (this.creating) {
				return;
			}
			if (!await this.confirmLeaveWithPendingChanges()) {
				return;
			}
			try {
				const { value } = await this.$prompt('请输入好友分组名称', '新建分组', {
					confirmButtonText: '创建',
					cancelButtonText: '取消',
					inputValue: '',
					inputValidator: (inputValue) => {
						const name = normalizeName(inputValue);
						if (!name) {
							return '分组名称不能为空';
						}
						if (name.length > 20) {
							return '分组名称不能超过 20 个字符';
						}
						return true;
					}
				});
				this.creating = true;
				const createdName = normalizeName(value);
				const createdGroup = await this.$http({
					url: '/friend/group',
					method: 'post',
					data: {
						name: createdName,
						friendIds: []
					}
				});
				const nextGroup = await this.reloadGroupsAndResolveGroup(
					createdGroup && createdGroup.id,
					createdName
				);
				if (!nextGroup) {
					throw new Error('创建成功，但分组列表未返回最新数据');
				}
				this.syncDraftFromGroup(nextGroup);
				await this.hydrateDraftFriendIds(nextGroup);
				this.$message.success('好友分组创建成功');
			} catch (error) {
				if (error === 'cancel' || error === 'close') {
					return;
				}
				this.$message.error(this.extractErrorMessage(error) || '创建好友分组失败');
			} finally {
				this.creating = false;
			}
		},
		async onDeleteGroup() {
			if (!this.activeGroup || this.saving) {
				return;
			}
			try {
				await this.$confirm(`确认删除好友分组“${this.activeGroup.name}”吗？`, '删除分组', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				});
				this.saving = true;
				await this.$http({
					url: `/friend/group/${this.activeGroup.id}`,
					method: 'delete'
				});
				const nextGroup = await this.reloadGroupsAndResolveGroup();
				this.syncDraftFromGroup(nextGroup);
				await this.hydrateDraftFriendIds(nextGroup);
				this.$message.success('好友分组已删除');
			} catch (error) {
				if (error === 'cancel' || error === 'close') {
					return;
				}
				this.$message.error(this.extractErrorMessage(error) || '删除好友分组失败');
			} finally {
				this.saving = false;
			}
		},
		async onSaveGroup() {
			if (!this.activeGroup || this.saving) {
				return;
			}
			await this.ensureActiveGroupMembersFullyHydrated();
			if (!this.hasPendingChanges) {
				this.$message.info('暂无需要保存的变更');
				return;
			}
			const nextName = normalizeName(this.draftName);
			if (!nextName) {
				this.$message.warning('分组名称不能为空');
				return;
			}
			this.saving = true;
			try {
				const currentGroupId = this.activeGroup.id;
				let group = this.activeGroup;
				if (nextName !== normalizeName(this.originName)) {
					group = await this.$http({
						url: `/friend/group/${group.id}`,
						method: 'put',
						data: {
							name: nextName
						}
					});
				}
				if (!sameIds(this.draftFriendIds, this.originFriendIds)) {
					group = await this.$http({
						url: `/friend/group/${group.id}/members`,
						method: 'put',
						data: {
							friendIds: normalizeIds(this.draftFriendIds)
						}
					});
				}
				const nextGroup = await this.reloadGroupsAndResolveGroup((group && group.id) || currentGroupId, nextName);
				if (!nextGroup) {
					throw new Error('保存成功，但分组列表未返回最新数据');
				}
				this.syncDraftFromGroup(nextGroup);
				await this.hydrateDraftFriendIds(nextGroup);
				this.$message.success('好友分组保存成功');
			} catch (error) {
				this.$message.error(this.extractErrorMessage(error) || '保存好友分组失败');
			} finally {
				this.saving = false;
			}
		},
		isFriendSelected(friendId) {
			return this.draftFriendIds.includes(friendId);
		},
		async onToggleFriend(friendId) {
			await this.ensureActiveGroupMembersFullyHydrated();
			this.onSetFriendSelected(friendId, !this.isFriendSelected(friendId));
		},
			onSetFriendSelected(friendId, checked) {
				if (!friendId) {
					return;
				}
				if (checked) {
					if (!this.draftFriendIds.includes(friendId)) {
						this.draftFriendIds = this.draftFriendIds.concat(friendId);
						if (this.draftFriendIds.length <= this.checkedViewLimit + 1) {
							this.checkedViewLimit = this.draftFriendIds.length;
						}
					}
					return;
				}
			this.draftFriendIds = this.draftFriendIds.filter((id) => id !== friendId);
		},
		selectAllSourceFriends() {
			const selectedIdSet = new Set(this.draftFriendIds);
			this.showFriends.forEach((friend) => {
				selectedIdSet.add(friend.id);
			});
			this.draftFriendIds = Array.from(selectedIdSet);
		},
		async waitUntilReadyForSelection() {
			if (this.openPromise) {
				try {
					await this.openPromise;
				} catch (error) {
					// open() 内已经做了错误提示，这里只做兜底等待。
				}
			}
		},
		async onSelectAll() {
			await this.waitUntilReadyForSelection();
			try {
				await this.ensureActiveGroupMembersFullyHydrated();
			} catch (error) {
				console.warn('FriendGroupManager 全选前补齐分组成员失败', error);
			}
			try {
				await this.ensureSourceFriendsFullyLoaded();
			} catch (error) {
				console.warn('FriendGroupManager 全量加载好友失败', error);
			}
			this.selectAllSourceFriends();
		},
			async onClearChecked() {
				try {
					await this.ensureActiveGroupMembersFullyHydrated();
				} catch (error) {
					console.warn('FriendGroupManager 清空前补齐分组成员失败', error);
				}
				this.draftFriendIds = [];
				this.checkedViewLimit = CHECKED_RESULT_PAGE_SIZE;
			},
			loadMoreSourceFriendsIfNeeded() {
				if (!this.show) {
					return;
				}
				if (this.friendStore.page.loading
					|| !this.friendStore.page.more
					|| !this.friendStore.page.cursor) {
					return;
				}
				this.friendStore.loadMoreFriendsFromCursor({
					maxPages: 1
				}).catch((error) => {
					console.warn('FriendGroupManager 列表续拉好友分页失败', error);
				});
			},
			onSourceListReachBottom() {
				this.loadMoreSourceFriendsIfNeeded();
			},
		onCheckedListReachBottom() {
			const nextLimit = Math.max(CHECKED_RESULT_PAGE_SIZE, Math.floor(Number(this.checkedViewLimit) || 0)) + CHECKED_RESULT_PAGE_SIZE;
			const maxCount = Math.max(this.checkCount, this.checkedFriends.length);
			this.checkedViewLimit = Math.min(maxCount, nextLimit);
		},
			extractErrorMessage(error) {
				if (error && typeof error.message === 'string' && error.message) {
					return error.message;
			}
			if (error && typeof error.msg === 'string' && error.msg) {
				return error.msg;
			}
			if (error && error.response && error.response.data) {
				const responseData = error.response.data;
				if (typeof responseData === 'string' && responseData) {
					return responseData;
				}
				if (typeof responseData.message === 'string' && responseData.message) {
					return responseData.message;
				}
			}
			return '';
		}
	}
};
</script>

<style scoped lang="scss">
.friend-group-manager {
	display: grid;
	grid-template-columns: minmax(240px, 260px) minmax(0, 1fr);
	gap: 10px;
	height: min(540px, calc(100vh - 154px));
	min-height: 0;

	&.is-mobile {
		grid-template-columns: minmax(0, 1fr);
		height: calc(100vh - 168px);
	}

	.panel-head {
		display: flex;
		flex-direction: column;
		gap: 8px;
		padding: 10px 12px;
		border-bottom: 1px solid var(--im-surface-panel-border);
	}

	.panel-meta {
		display: flex;
		align-items: center;
		justify-content: space-between;
		gap: 10px;
	}

	.panel-title {
		font-size: 14px;
		font-weight: 600;
		color: var(--im-text-color);
		text-align: left;
	}

	.compact-title {
		display: inline-flex;
		align-items: center;
		gap: 6px;
	}

	.result-badge,
	.inline-count {
		display: inline-flex;
		align-items: center;
		justify-content: center;
		min-width: 22px;
		height: 22px;
		padding: 0 7px;
		border-radius: 999px;
		background: rgba(var(--im-primary-rgb), 0.08);
		color: var(--im-color-primary);
		font-size: 12px;
		font-weight: 600;
	}

	.group-sidebar,
	.group-detail,
	.detail-empty-state,
	.left-box,
	.right-box {
		min-width: 0;
		border: 1px solid var(--im-surface-panel-border);
		border-radius: 10px;
		background: var(--im-surface-panel-soft);
		overflow: hidden;
	}

	.group-sidebar,
	.group-detail {
		display: flex;
		flex-direction: column;
		min-height: 0;
	}

	.sidebar-head {
		flex-shrink: 0;
	}

	.sidebar-scroll,
	.scroll-box {
		flex: 1;
		min-height: 0;
	}

	.group-item {
		margin: 6px;
		padding: 10px 12px;
		border-radius: 8px;
		border: 1px solid transparent;
		cursor: pointer;
		transition: all 0.2s ease;

		&:hover {
			background: var(--im-control-soft-bg-hover);
		}

		&.active {
			border-color: rgba(var(--im-primary-rgb), 0.24);
			background: rgba(var(--im-primary-rgb), 0.08);
		}
	}

	.group-item-head {
		display: flex;
		align-items: center;
		justify-content: space-between;
		gap: 10px;
	}

	.group-name {
		flex: 1;
		min-width: 0;
		font-size: 14px;
		font-weight: 600;
		color: var(--im-text-color);
		overflow: hidden;
		text-overflow: ellipsis;
		white-space: nowrap;
		text-align: left;
	}

	.group-count {
		flex-shrink: 0;
		font-size: 12px;
		color: var(--im-text-color-light);
		font-weight: 500;
	}

	.detail-head {
		flex-shrink: 0;
	}

	.detail-title-row {
		display: flex;
		align-items: center;
		justify-content: space-between;
		gap: 10px;
	}

	.detail-actions {
		display: inline-flex;
		align-items: center;
		gap: 8px;
	}

	.detail-body {
		flex: 1;
		min-height: 0;
		display: grid;
		grid-template-columns: minmax(0, 1fr) minmax(220px, 240px);
		gap: 8px;
		padding: 10px;

		@media (max-width: 900px) {
			grid-template-columns: minmax(0, 1fr);
		}
	}

	.left-box,
	.right-box {
		display: flex;
		flex-direction: column;
		min-height: 0;
	}

	.left-box {
		::v-deep .virtual-content {
			padding: 4px 0;
		}
	}

	.select-tools,
	.selection-head {
		display: flex;
		align-items: center;
		justify-content: space-between;
		gap: 8px;
	}

	.select-tools__actions {
		display: inline-flex;
		align-items: center;
		gap: 6px;
		margin-left: auto;
	}

	.selection-head {
		flex-direction: row;
	}

	.icon-btn {
		padding: 0;
	}

	.add-tip {
		margin-left: auto;
		flex-shrink: 0;
		font-size: 12px;
		color: var(--im-color-primary);
	}

	.checked-item {
		display: flex;
		align-items: center;
		gap: 10px;
		padding: 9px 10px;
		margin: 4px;
		border-radius: 8px;
		border: 1px solid var(--im-control-border);
		background: var(--im-control-soft-bg);
		cursor: pointer;
		transition: background-color 0.2s ease, border-color 0.2s ease;

		&:hover {
			background: rgba(var(--im-primary-rgb), 0.05);
			border-color: rgba(var(--im-primary-rgb), 0.12);
		}
	}

	.checked-scroll-box {
		::v-deep .virtual-content {
			padding: 4px;
			box-sizing: border-box;
		}
	}

	.checked-main {
		flex: 1;
		min-width: 0;
		text-align: left;
	}

	.checked-name {
		font-size: 13px;
		font-weight: 600;
		color: var(--im-text-color);
		overflow: hidden;
		text-overflow: ellipsis;
		white-space: nowrap;
	}

	.close {
		color: var(--im-text-color-light);
	}

	.list-empty-state,
	.detail-empty-state {
		flex: 1;
	}
}

.friend-group-manager-shell {
	::v-deep .friend-group-manager-dialog {
		border-radius: 12px;
		overflow: hidden;
	}

	::v-deep .el-dialog__body {
		padding: 12px 14px 10px;
	}

	::v-deep .el-dialog__footer {
		padding: 8px 14px 14px;
		border-top: 1px solid var(--im-surface-panel-border);
	}
}
</style>
